module.exports={
    "over_size_message":"Yüklediğiniz resim 10MB'ın üzerinde. Dosyanızı yüklemek için sıkıştıracağız. Yüklemeye devam etmek için lütfen \"Onayla\"yı tıklayın.",
    "file_type_error":"Yüklediğiniz dosya bir resim değil! Lütfen tekrar yüklemeyi deneyin.",
    "upload_error":"Yükleme Hatası! (Hata Kodu: 2000) Lütfen tekrar deneyiniz.",
    "watermark_remove_over_size":"Yüklediğiniz resim 5MB'ın üzerinde. Ücretsiz Çevrimiçi Görüntü Kompresörümüzü kullanmanız önerilir. <a class=\"jump-link\" href=\"https://www.anymp4.com/tr/image-compressor-online/\">Daha fazla bilgi</a> için tıklayın",
    "watermark_remove_file_type_error":"Yüklediğiniz dosya bir resim değil, lütfen tekrar yükleyin.",
    "watermark_remove_image_type_error":"Görüntü formatı desteklenmiyor. Yalnızca JPG, JPEG, PNG ve BMP'yi destekliyoruz.",
    "watermark_remove_upload_error":"Tanıma hatası (hata kodu: 2001), lütfen tekrar deneyin...",
    "watermark_remove_processing":"Görüntü işleniyor...",
    "watermark_remove_not_save":"Seçtiğiniz alan korunmayacaktır. Kırpmak istediğinizden emin misiniz?",
    "watermark_remove_back_home":"Mevcut durum kaydedilmeyecek. Yuva'ya geri dönmek istediğinizden emin misiniz?",
    "watermark_remove_new_image":"Mevcut durum kaydedilmeyecek. Yeni bir resim seçmek istediğinizden emin misiniz?",
    "watermark_select":"Seçme",
    "watermark_select_area":"Kaldır'a tıklamadan önce lütfen silmek istediğiniz filigran alanını seçin.",
    "watermark_beyond_12k":"Seçilen görüntü 12K çözünürlüğü aşıyor. Üzgünüz, şu anda işleme koyamıyoruz",
    "watermark_beyond_pixel_1":"Seçilen resim çözünürlüğü <span>%spx</span><span>&times;%spx</span> değerini aşıyor. İşlenemez, lütfen tekrar seçin.",
    "watermark_beyond_pixel_2":"Ziyaretçiler yalnızca <span>%s</span> görüntüleri <span>%spx</span>x<span>%spx</span> üzerinde çözünürlüğe sahip işleyebilir, lütfen giriş yapın ve kullanmaya devam edin.",
    "watermark_beyond_size_1":"Seçilen resim boyutu <span>%sMB</span>'i aşıyor. İşlenemez, lütfen tekrar seçin.",
    "watermark_beyond_size_2":"Seçilen resim boyutu <span>%sMB</span>'i aşıyor, ancak ziyaretçiler yalnızca <span>%sMB</span>'den küçük resimleri işleyebilir. Lütfen giriş yapın ve kullanmaya devam edin.",
    "no_user_down":"Ziyaretçiler yalnızca orijinal kalitede <span>%s</span> görsel indirebilir. Lütfen giriş yapın ve indirmeye devam edin. Ayrıca, giriş yaptıktan sonra 7 günlük geçmişi saklayabilirsiniz. Genişliği veya yüksekliği <span>%spx</span> olan resimleri indirmeye devam edin.",
    "no_down_rights":"Orijinal kalitede HD görüntüler indirilemiyor, lütfen planınızı yükseltin! Ayrıca, düşük kaliteli resimleri <span>%spx</span> ile indirmeye devam edebilirsiniz.",
    "error_40001":"Hata: 40001. Lütfen bizimle iletişime geçin",
    "error_40099":"Hata: 40099. Lütfen bize ulaşın",
    "down_btn":"İndirme hazırlanıyor, lütfen bir saniye bekleyin...",
    "noRemove_down_btn":"Filigranları kaldırmak için hiçbir şey yapmadınız. Lütfen kaldırmak istediğiniz filigranı seçin ve Kaldır düğmesine tıklayın. Ardından resminizi indirebilirsiniz.",
    "history_open":"Değiştirilen resim açılıyor, lütfen biraz bekleyin...",
    "maskRightsMonitor_info":"Avantaj yükseltme sayfası yeni bir sekmede açıldı ve planınız yükseltmeden sonra otomatik olarak senkronize edilecek.",
    "maskLoginMonitor_info":"Açılış sayfası açıldı, lütfen giriş işlemini tamamlayın. Giriş yaptıktan veya başarılı bir şekilde kayıt olduktan sonra, bu sayfa otomatik olarak senkronize edilecektir, lütfen kapatmayın.",
    "photo_rights_info":"Orijinal kalitede <span><i class=\"num\">2</i> HD görüntü(ler)</span> şu anda indirilebilir. <a href=\"https://account.anymp4.com\" target=\"_blank\">Ayrıntıları Görüntüle>></a>",
    "rights_original":"\"Kalite kaybını azaltmak için Görüntü İyileştirici işlevini kullanın\" ayarını açmak için hesabınızı yükseltmeniz gerekir!",
    "Brush":"Fırçalamak",
    "Lasso":"Kement",
    "Polygonal":"Çokgen",
    "Eraser":"Silgi",
    "Free":"Özgür",
    "More":"Daha:",
    "Select":"Seçme",
    "Remove":"Kaldırmak",
    "BrushSize":"Fırça boyutu:",
    "AspectRatio":"En Boy Oranı:",
    "Upload":"Yeni fotoğraf",
    "History":"Tarih",
    "Login":"Giriş yapmak",
    "MyAccount":"Hesabım",
    "Logout":"Çıkış Yap",
    "Usinghelp":"Yardımı kullanma >>",
    "Enhancer":"Kalite kaybını azaltmak için Görüntü İyileştirici işlevini kullanın",
    "Download":"İndirmek",
    "Guide":"Kılavuz",
    "Polygonal1":"Çokgen",
    "Polygonal_info":"Bir seferde bir nokta belirlemek için farenin sol düğmesine tıklayın.",
    "Lasso1":"Kement:",
    "Lasso_info":"Filigran alanını kementlemek için sol fare düğmesine uzun basın.",
    "Brush1":"Fırçalamak:",
    "Brush_info":"Tam olarak seçmek için farenin sol düğmesine uzun basın.",
    "Eraser1":"Silgi:",
    "Eraser_info":"Seçilen alandan gereksiz kısımları silin.",
    "Click":"Tıklamak",
    "the":"en",
    "click_info":"İstenmeyen filigranı silmeye başlamak için düğmesine basın.",
    "PleaseUploadImages":"Lütfen resimleri yükleyin.",
    "CropInfo":"Filigran kaldırma işlemi tamamlandıktan sonra, resminizi kaydetmeden önce kırpmak için Kırp düğmesini tıklayabilir veya mevcut resmi doğrudan kaydetmek için İndir düğmesini tıklayabilirsiniz.",
    "Crop":"Mahsul",
    "Back":"Geri",
    "DownloadCropped":"Kırpılmış İndir",
    "Cancel":"İptal etmek",
    "FreeWatermarkRemover":"Ücretsiz Filigran Kaldırıcı",
    "Processing":"İşleme...",
    "NewImage":"Yeni görüntü",
    "Retry":"Yeniden",
    "Yes":"Evet",
    "No":"Numara",
    "FailureFeedback":"Arıza Geribildirimi",
    "removeTip":"Filigran alanını seçtikten sonra, filigranı silmek için lütfen Kaldır'a tıklayın.",
    "rightDown":"Düşük Kaliteli Görüntüleri İndirin",
    "history_will":"Sonra sona erecek",
    "Expired":"(Süresi doldu)",
	"uploadImage":"Fotoğraf yükleniyor",
    "uploadImageInfo":"Veya filigranı kaldırmak için resim dosyanızı buraya bırakın!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain TWO HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Sınırsız",
    "watermark_beyond_pixel_3":"Seçilen resim <span>%s&times;%s çözünürlüğünü</span> aşıyor, lütfen önce planınızı yükseltin.",
    "watermark_beyond_size_3":"Seçilen resim <span>%sMB</span> değerini aşıyor, lütfen önce planınızı yükseltin.",
    "no_user_login":"Giriş yapan yeni kullanıcılar, İKİ HD orijinal görsel indirme avantajı elde edebilir.<span class=\"loginMaskbtn\">Hemen giriş yapın>></span>",
    "Upgrade":"Güncelleme",
    "Loading":"Yükleniyor…",
    "SelectAll":"Hepsini seç",
    "Open":"Açık",
    "Delete":"Silmek",
    "Clear":"Geçersiz temizle",
    "noHistory":"Geçmiş Yok",
    "Close":"Kapat",
    "buyUserInfo":"tebrikler! Başarıyla yükselttiniz. Lütfen ana sayfaya dönün ve bu ürünü kullanın.",
    "buyNoUserInfo":"Tebrikler! Başarıyla yükselttiniz. Avantajlar, yükseltme yaparken bıraktığınız e-posta adresine bağlandı. Lütfen <span class=\"loginMaskbtn\">avantajlardan yararlanmak için giriş yapmak</span> için kayıtlı veya e-posta adresine bağlı hesabı kullanın. Bir hesabı e-posta adresiyle kaydetmediyseniz veya bağlamadıysanız, lütfen <span class=\"registerMaskbtn\">bir hesap kaydetmek için e-posta adresini kullanın</span> veya bu e-postaya başka hesaplar bağlayın avantajları kullanmak için posta adresi.",
    "GetStarted":"Başlamak",
    "AccessTo":"Erişim:",
    "imagesOfwatermarkremoval":"filigran kaldırma görselleri",
    "upTo":"kadar",
    "perImage":"görüntü başına",
    "Support":"Destek olmak",
    "resolution":"çözüm",
    "PrepaidPackage":"Ön Ödemeli Paket",
    "PayasYouGo":"Kullandıkça Öde",
    "TaxIncl":"Vergi dahil.",
    "Checkout":"Çıkış yapmak",
    "imagesDay":"resim/gün",
    "imagesMonthly":"görüntü/aylık",
    "image":"görüntü",
    "images":"Görüntüler",
    "imageSize":"Görüntü boyutu",
    "buyInfo1":"Üçüncü taraf <span>geliştirici</span> entegrasyonları",
    "buyInfo2":"Düzenleme geçmişi 7 gün boyunca geçerlidir",
    "buyInfo3":"Öncelikli işleme",
    "buyInfo4":"7x24 müşteri desteği",
    "buyInfo5":"24 saat sonra süresi doldu",
    "buyInfo6":"Abonelik yok. Otomatik yenileme yok!",
    "buyInfo7":"Her zaman sonsuza kadar kullanılabilir",
    "dayPlan":"1 Günlük Plan",
    "Lifetime":"Ömür",
}